// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e7af5876","977":"7544f2e3"}[chunkId] + ".chunk.js";
};